import { api } from "../client";
import {
  BasketPositionExtraFields,
  BasketPositionFields,
  PartialBasketPositionExtraFields,
  PartialBasketPositionFields,
} from "../schema/BasketPosition";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<BasketPositionFields, BasketPositionExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialBasketPositionFields,
  PartialBasketPositionExtraFields
>;

export const getBasketPositions = async (config?: ApiRequestConfig) => {
  return api.get<BasketPositionFields, BasketPositionExtraFields>(
    "basket_positions",
    config
  );
};
export const getBasketPosition = (id: number, config?: ApiRequestConfig) => {
  return api.get<BasketPositionFields, BasketPositionExtraFields>(
    `basket_positions/${id}`,
    config
  );
};

export const createBasketPosition = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialBasketPositionFields,
    PartialBasketPositionExtraFields
  >("basket_positions", config);
};
export const updateBasketPosition = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialBasketPositionFields,
    PartialBasketPositionExtraFields
  >(`basket_positions/${id}`, config);
};
export const deleteBasketPosition = (id: number) => {
  return api.remove<BasketPositionFields, BasketPositionExtraFields>(
    `basket_positions/${id}`
  );
};
